<template>
    <div>
        <el-dialog :visible.sync="bsDetailDialog" width="48%" top="15vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false v-loading="loading"  element-loading-text="数据加载中" element-loading-spinner="el-icon-loading"  
               element-loading-background="rgba(0.8, 0, 0, 0.3)" @close="closeDialog">
        <el-card style="height: 500px">
            <el-table :data="response.storeInfo" style="width: 100%" height="430" border :header-cell-style="{background:'#01DFD7',color:'#fff'}">
                <el-table-column label="门店编号" align="center" prop="code" width="150"></el-table-column>
                <el-table-column label="门店名称" align="center" prop="name"></el-table-column>
                <el-table-column label="门店单价" align="center">
                    <template slot-scope="scope">{{scope.row.unitPrice / 100}}元/{{scope.row.sku}}分钟 </template>
                </el-table-column>
                <el-table-column label="联系人" align="center" prop="contactName"></el-table-column>
                <el-table-column label="联系方式" align="center" prop="contactPhone"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="warning" plain size="small" @click="showDevice(scope.row.storeDeviceList)">查看设备</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        </el-dialog>

        <el-dialog :visible.sync="storeDeviceDialog" width="48%" top="20vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false @close="closeDeviceDialog">
        <el-card style="height: 400px">
          <el-table :data="devices" style="width: 100%" height="330" border :header-cell-style="{background:'#01DFD7',color:'#fff'}">
                <el-table-column label="设备编号" align="center" prop="deviceId" width="200"></el-table-column>
                <el-table-column label="设备类型" align="center">
                     <template slot-scope="scope">{{scope.row.socket}}仓设备</template>
                </el-table-column>
                <el-table-column label="状态" align="center" prop="deviceState"></el-table-column>
                <el-table-column label="部署时间" align="center">
                    <template slot-scope="scope">{{scope.row.deployTime | formatDate}}</template>
                </el-table-column>
            </el-table>
        </el-card>
    </el-dialog>
    </div>
</template>
<script>
import {getBsRelationById} from '../../api/relation/businessstorerelation.js'
import { formatDate } from "../../utils/date";
export default {
    data() {
        return {
            bsDetailDialog: false,
            loading: false,
            card: "1",
            response: {storeInfo: [],total: 0},
            query: {current: 1, size: 10},
            operationAccountParams: {
                identity: 'bs',
                id: '',
                state: ''
            },
            storeDeviceDialog: false,
            devices: []
        }
    },
    methods: {
        init(id) {
            this.bsDetailDialog = true;
            getBsRelationById(id).then(result=>{
                this.response.storeInfo = result.data;
            })
        },

        /**
         * 关闭弹窗
         */
        closeDialog(){
            this.bsDetailDialog = false;
            this.card = "1";
            this.response.storeInfo = [];
        },

        /**
         * 卡片选择
         */
        chooseTabs(value){
            this.response.storeInfo = [];
            if(value.name === "2"){
                getbsStoreInfo(this.response.bsInfo.bsId,{current: this.query.current, size: this.query.size}).then(result=>{
                    this.response.storeInfo = result.data.records;
                    this.response.total = result.data.total;
                })
            }
        },

        /**
         * 查看门店设备
         */
        showDevice(devices){
            this.devices = devices;
            this.storeDeviceDialog = true;
        },

        /**
         * 设备弹窗关闭
         */
        closeDeviceDialog(){
            this.devices = [];
        }
    },
    filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
  }
}
</script>
<style scoped>
.el-pagination{
    margin-left: 15%;
}
</style>>


// WEBPACK FOOTER //
// src/pages/relation/bsDetail.vue